import React from "react";
import styled from "styled-components";
import { injectIntl } from "react-intl";
import Button from "components3/src/Button";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 48px;
`;

const Header = styled.h1`
  margin: 16px;
`;

const Text = styled.h2`
  margin: 16px;
`;

const URL = styled.h3``;

const IconWrapper = styled.div`
  margin: 20dvh;
`;

const Icon = styled.i``;

const View404 = ({ intl, erroneousURL }) => {
  return (
    <Container>
      <Header>{intl.formatMessage({ id: "View404.heading" })}</Header>
      {erroneousURL ? (
        <>
          <Text>
            {intl.formatMessage({ id: "View404.nothingToBeFoundOn" })}
          </Text>
          <URL>{erroneousURL}</URL>
        </>
      ) : (
        <Text>{intl.formatMessage({ id: "View404.nothingToBeFound" })}</Text>
      )}
      <IconWrapper>
        <Icon className="fa-solid fa-pancakes fa-10x" />
      </IconWrapper>
      <Button
        extra={{ label: "View404.backToHome" }}
        onClick={() => (window.location = "/home")}
      />
    </Container>
  );
};

export default injectIntl(View404);
